import { useQuery } from "react-query";
import { default as config } from "common/config/config";
import { Queries } from "ui/query/queries";
import ServiceFactory from "domain/adapter/ServiceFactory";

export default function useGetNearBalance(address: string | undefined) {
    const safeAddress = address as string;

    return useQuery(
        [Queries.ACCOUNT_NEAR_BALANCE, address],
        async () => {
            const nearService = ServiceFactory.nearService;
            await nearService.connect();
            return nearService.getBalance(safeAddress);
        },
        { enabled: Boolean(address), refetchInterval: config.refetchIntervals.nearBalance },
    );
}
